import { makeStyles } from 'tss-react/mui';
import { pickIf } from '../../../utils/pickIf';
import { styleCondition } from '../../../utils/styleCondition';

// Constants
import {
  FONT_WEIGHT_REGULAR,
  FONT_WEIGHT_SEMIBOLD,
} from '../../../constants/typography';

export const useStyles = makeStyles()(
  (
    theme,
    { onlyContent, isAuthPage, onlyLogoLink, isKiteUser, isActiveSearch } = {},
  ) => ({
    root: {
      backgroundColor: 'white',
      borderBottomLeftRadius: 10,
      borderBottomRightRadius: 10,
      display: 'flex',
      flexDirection: 'row',
      height: 80,
      justifyContent: pickIf(onlyContent, 'start', 'center'),
      boxShadow: '0px 5px 17px rgba(48, 85, 107, 0.2)',
      ...(onlyContent && {
        boxShadow: 'none',
        alignItems: 'center',
      }),
      [theme.breakpoints.down('lg')]: {
        height: pickIf(onlyContent, 0, 70),
      },
      [theme.breakpoints.down('md')]: {
        height: 54,
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...styleCondition(theme.isMobileDevice, {
          height: pickIf(onlyContent, 0, 70),
        }),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...styleCondition(theme.isMobileDevice, {
          height: 54,
        }),
      },
    },
    logo: {
      display: 'flex',
      height: 60,
      width: 60,
      [theme.breakpoints.down('lg')]: {
        height: 48,
        width: 48,
      },
      [theme.breakpoints.down('md')]: {
        height: 40,
        width: 40,
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...styleCondition(theme.isMobileDevice, {
          height: 48,
          width: 48,
        }),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...styleCondition(theme.isMobileDevice, {
          height: 40,
          width: 40,
        }),
      },
    },
    toolbar: {
      display: 'flex',
      justifyContent: pickIf(
        isAuthPage || onlyLogoLink,
        'center',
        'space-between',
      ),
      minHeight: '20px',
      width: 1180,
      [theme.breakpoints.down('md')]: {
        paddingLeft: theme.spacing(1.5),
        paddingRight: theme.spacing(1.5),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...styleCondition(theme.isMobileDevice, {
          paddingLeft: theme.spacing(1.5),
          paddingRight: theme.spacing(1.5),
        }),
      },
    },
    linkContainer: {
      display: 'flex',
      fontWeight: pickIf(isKiteUser, FONT_WEIGHT_REGULAR, FONT_WEIGHT_SEMIBOLD),
      justifyContent: 'space-between',
      marginLeft: 'auto',
      width: 777,
      [theme.breakpoints.down('lg')]: {
        marginLeft: 0,
        flexDirection: 'column',
        paddingTop: theme.spacing(3.5),
        width: '100%',
      },
      [theme.breakpoints.down('md')]: {
        paddingLeft: theme.spacing(1),
        paddingTop: theme.spacing(2),
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...styleCondition(theme.isMobileDevice, {
          marginLeft: 0,
          flexDirection: 'column',
          paddingTop: theme.spacing(3.5),
          width: '100%',
        }),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...styleCondition(theme.isMobileDevice, {
          paddingLeft: theme.spacing(1),
          paddingTop: theme.spacing(2),
        }),
      },
    },
    link: {
      alignItems: 'center',
      display: 'flex',
      color: 'black',
      textDecoration: 'none',
      [theme.breakpoints.down('lg')]: {
        paddingBottom: theme.spacing(1.5),
        paddingTop: theme.spacing(1.5),
      },
      [theme.breakpoints.down('md')]: {
        paddingBottom: theme.spacing(1.1),
        paddingTop: theme.spacing(1.1),
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...styleCondition(theme.isMobileDevice, {
          paddingBottom: theme.spacing(1.5),
          paddingTop: theme.spacing(1.5),
        }),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...styleCondition(theme.isMobileDevice, {
          paddingBottom: theme.spacing(1.1),
          paddingTop: theme.spacing(1.1),
        }),
      },
    },
    icon: {
      marginRight: 8,
    },
    logoutButton: {
      color: 'black !important',
      fontWeight: pickIf(isKiteUser, FONT_WEIGHT_REGULAR, FONT_WEIGHT_SEMIBOLD),
      textTransform: 'initial',
      marginLeft: 'auto',
      '&:hover': {
        backgroundColor: 'initial',
      },
      [theme.breakpoints.down('lg')]: {
        padding: 0,
        marginBottom: theme.spacing(3),
        marginLeft: `-${theme.spacing(0.5)}`,
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...styleCondition(theme.isMobileDevice, {
          fontSize: '14px !important',
          padding: 0,
          marginTop: theme.spacing(4),
          marginBottom: theme.spacing(3),
          marginLeft: `-${theme.spacing(0.5)}`,
        }),
      },
    },
    activeLink: {
      color: pickIf(isKiteUser, theme.palette.primary2, theme.palette.primary1),
      '& > svg path': {
        stroke: pickIf(
          isKiteUser,
          theme.palette.primary2,
          theme.palette.primary1,
        ),
        '&#stroke-none': {
          stroke: 'none',
        },
        '&#fill-only': {
          fill: pickIf(
            isKiteUser,
            theme.palette.primary2,
            theme.palette.primary1,
          ),
          stroke: 'none',
        },
      },
    },
    rights: {
      color: '#C6CAC6',
      fontSize: 14,
      '& div': {
        display: 'inline',
      },
      [theme.breakpoints.down('md')]: {
        fontSize: 12,
        '& div': {
          display: 'block',
        },
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...styleCondition(theme.isMobileDevice, {
          fontSize: 12,
          marginBottom: theme.spacing(1),
          '& div': {
            display: 'block',
          },
        }),
      },
    },
    spacer: {
      padding: theme.spacing(1.8),
      [theme.breakpoints.down('md')]: {
        padding: theme.spacing(0.9),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...styleCondition(theme.isMobileDevice, {
          padding: theme.spacing(0.9),
        }),
      },
    },
    menuButton: {
      padding: 2,
    },
    additionalTitle: {
      alignItems: 'center',
      display: 'flex',
      color: 'black',
      fontWeight: 700,
      fontSize: 36,
      maxWidth: 1180,
      paddingLeft: 26,
      paddingRight: 26,
      width: '100%',
      margin: '50px auto 0',
    },
    searchIcon: {
      boxShadow: '0px 5px 17px rgba(44, 112, 172, 0.2)',
      height: 36,
      marginLeft: theme.spacing(1.5),
      width: 36,
    },
    mainLogo: {
      display: pickIf(isActiveSearch, 'none', 'initial'),
    },
  }),
);
